import { API_BASE_URL } from '@synergy/config';
import { createAction } from '@reduxjs/toolkit';

import { AppDispatch } from '../../store/store';
import { SponsorBannerApi } from '../api/sponsor-banner-api';
import { SponsorBannerDto } from '../models/dto/sponsor-banner-dto';

const api = new SponsorBannerApi(API_BASE_URL);

export const sponsorBannersReceived = createAction<SponsorBannerDto[]>('sponsor-banner/loaded');

export const fetchSponsorBanners = () => async (dispatch: AppDispatch) => {
    const response = await api.getSponsorBanners();
    if (response.success) {
        dispatch(sponsorBannersReceived(response.result));
    }
    // We don't show an error if failed - just don't display any banners
};
